import * as React from 'react';

function SvgSort(props) {
  return (
    <svg viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M8.388 11.473c.076.712.961 1.046 1.488.519l2.918-2.917a.875.875 0 10-1.238-1.238l-1.423 1.424V2.623a.875.875 0 00-1.75 0v8.75l.005.1zm-2.78-8.947c-.077-.713-.962-1.047-1.49-.52L1.202 4.924A.875.875 0 102.44 6.16l1.423-1.424v6.638a.875.875 0 101.75 0v-8.75l-.005-.1z" />
    </svg>
  );
}

export default SvgSort;
